import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Checkbox } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { FC, useEffect, useState } from "react";
import { Formater, TypeRecords } from "src/framework/commons";
import { FinanciamentosPlanosTypes } from "src/types";
import { AVISO_ENTRADA_FINANCIAMENTO_FORMALIZACAO } from "../constants";

export interface PlanosDataTableProperties {
    planos: FinanciamentosPlanosTypes[];
    onChange: (plano: FinanciamentosPlanosTypes) => void;
    disableCheckbox?: boolean;
}

const PlanosDataTable: FC<PlanosDataTableProperties> = ({
    planos,
    onChange,
    disableCheckbox = false
}) => {

    const [planoSelecionado, setPlanoSelecionado] = useState<FinanciamentosPlanosTypes>();

    useEffect(() => {

        const idx = planos.findIndex((f: FinanciamentosPlanosTypes) => f.selecionado === true);
        if (idx > -1) {
            setPlanoSelecionado(planos[idx] || null);
        }
    }, [planos])

    return <>
        <div className="PlanosDataTable">
            <div className="X12">
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" padding="checkbox"></TableCell>
                                <TableCell align="right">Valor de Entrada*</TableCell>
                                <TableCell align="center">Parcelas</TableCell>                                
                                <TableCell align="right">Taxa</TableCell>
                                <TableCell align="right">Valor da Parcela</TableCell>
                                <TableCell align="center">Carência (Dias)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {planos?.map((plano: FinanciamentosPlanosTypes) => (
                                <TableRow>
                                    
                                        <TableCell align="center" padding="checkbox">
                                            <Checkbox
                                                checked={(plano.id === planoSelecionado?.id ? true : false) || planos.length === 1}
                                                disabled={disableCheckbox ||  planos.length === 1}
                                                onChange={(event: any) => {
                                                    setPlanoSelecionado(plano);

                                                    if (planoSelecionado) {
                                                        onChange(plano);
                                                    }
                                                }} /></TableCell>
                                    <TableCell align="right">{Formater.toString(plano.valor_entrada, TypeRecords.CURRENCY)}</TableCell>
                                    <TableCell align="center">{plano.parcelas}</TableCell>                                    
                                    <TableCell align="right">{Formater.toString(plano.taxa, TypeRecords.PERCENT2)}</TableCell>
                                    <TableCell align="right">{Formater.toString(plano.valor_parcela, TypeRecords.CURRENCY)}</TableCell>
                                    <TableCell align="center">{plano.carencia}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div className="row" style={ { paddingBottom: "5px", paddingTop: "5px" } }>
                <div className="X12">
                    <Alert severity="warning">
                        {AVISO_ENTRADA_FINANCIAMENTO_FORMALIZACAO}
                    </Alert>
                </div>
            </div>
        </div>
    </>
}

export { PlanosDataTable }

